var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1594 5.95438C15.9484 5.74348 15.6623 5.625 15.364 5.625C15.0657 5.625 14.7796 5.74348 14.5686 5.95438L8.99988 11.5231L3.43113 5.95438C3.21896 5.74946 2.93478 5.63606 2.63981 5.63863C2.34484 5.64119 2.06267 5.7595 1.85409 5.96809C1.6455 6.17667 1.52719 6.45884 1.52463 6.75381C1.52206 7.04878 1.63546 7.33296 1.84038 7.54513L8.20451 13.9093C8.41548 14.1202 8.70157 14.2386 8.99988 14.2386C9.29819 14.2386 9.58429 14.1202 9.79526 13.9093L16.1594 7.54513C16.3703 7.33417 16.4888 7.04807 16.4888 6.74976C16.4888 6.45145 16.3703 6.16535 16.1594 5.95438V5.95438Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.985426aa51ed1f5d86bd5f66240ca33e.svg";
export { ForwardRef as ReactComponent };